import { useLocale, type Locale } from "./locale";

/** Shared chrome strings (Header, Footer, common UI). */
export const CHROME = {
  en: {
    "nav.products": "Products",
    "nav.platform": "Platform",
    "nav.solutions": "Solutions",
    "nav.teams": "Teams",
    "nav.pricing": "Pricing",
    "nav.signIn": "Sign in",
    "nav.getStarted": "Get Started",
    "nav.openMenu": "Open menu",
    "nav.shopAll": "Shop all →",
    "nav.allProducts": "All products",
    "nav.allProductsDesc": "NFC business cards powered by Banana AI.",
    "nav.forTeams": "For teams",
    "nav.teamsHeadline": "Are you a team? Get a custom quote for your entire team — or teams.",
    "nav.teamsBody": "Branded cards, bulk pricing, central dashboard and shared CRM. Fulfilled in one go.",
    "nav.talkToSales": "Talk to sales →",
    "nav.bulkPricing": "Bulk pricing",
    "nav.bulkBody": "Up to 40% off for 25+ cards.",
    "nav.getQuote": "Get a quote →",
    "nav.brandedQ": "Need branded cards for your team?",
    "nav.whatsNew": "What's new",
    "nav.brainNew": "AI Brain 2.0 — your second brain, now multilingual.",
    "nav.brainBody": "Scan, enrich and follow up in 50+ languages. Available on every plan.",
    "nav.readAnnouncement": "Read announcement →",
    "nav.tryFree": "Try it free",
    "nav.tryFreeBody": "14-day Pro trial — no card.",
    "nav.getStartedArrow": "Get started →",
    "nav.overviewQ": "Looking for the full platform overview?",
    "nav.seePlans": "See plans & pricing →",
    "nav.customerStory": "Customer story",
    "nav.northbeam": "65× faster follow-up at Northbeam.",
    "nav.readStory": "Read the story →",
    "nav.shopProducts": "Shop products",
    "nav.nfcShop": "NFC Shop",
    "nav.about": "About",
    "nav.readAnnouncementMobile": "Read announcement",
    "footer.tagline": "The AI-powered contact platform that helps modern professionals share who they are, capture who they meet, and never lose the context.",
    "footer.col.platform": "Platform",
    "footer.col.solutions": "Solutions",
    "footer.col.company": "Company",
    "footer.col.resources": "Resources",
    "footer.platform.cards": "Digital Cards",
    "footer.platform.ai": "AI Brain",
    "footer.platform.contacts": "Contacts",
    "footer.platform.bookings": "Bookings",
    "footer.platform.contracts": "Contracts",
    "footer.platform.automations": "Automations",
    "footer.platform.analytics": "Analytics",
    "footer.solutions.sales": "Sales Teams",
    "footer.solutions.founders": "Founders",
    "footer.solutions.realEstate": "Real Estate",
    "footer.solutions.enterprise": "Enterprise",
    "footer.company.about": "About",
    "footer.company.pricing": "Pricing",
    "footer.company.shop": "NFC Shop",
    "footer.company.contact": "Contact",
    "footer.resources.help": "Help center",
    "footer.resources.articles": "Articles",
    "footer.resources.legal": "Legal",
    "footer.resources.security": "Security",
    "footer.resources.antiSpam": "Anti-Spam Policy",
  "footer.resources.returns": "Returns Policy",
    "footer.copyright": "All rights reserved.",
    "footer.madeWith": "Made with care for people who meet people.",
    "switcher.label": "Language",
    "viOnlyEnNotice": "This page is currently only available in English.",
    "hdr.group.identity": "Identity & Sharing",
    "hdr.group.ai": "AI",
    "hdr.group.crm": "CRM",
    "hdr.group.run": "Run your business",
    "hdr.item.cards.t": "Digital Business Cards",
    "hdr.item.cards.d": "Beautiful, customizable profiles for everyone on your team.",
    "hdr.item.nfc.t": "NFC Cards",
    "hdr.item.nfc.d": "Premium NFC products that tap to share — instantly.",
    "hdr.item.sharing.t": "Sharing & Networking",
    "hdr.item.sharing.d": "QR codes, Apple & Google Wallet, email signatures.",
    "hdr.item.brain.t": "AI Brain",
    "hdr.item.brain.d": "Your second brain for every contact and conversation.",
    "hdr.item.enrich.t": "AI Enrichment",
    "hdr.item.enrich.d": "Auto-fill every contact with title, company and signals.",
    "hdr.item.aitools.t": "AI Tools",
    "hdr.item.aitools.d": "Writer, translator, summarizer and lead scorer.",
    "hdr.item.contacts.t": "Contacts",
    "hdr.item.contacts.d": "Capture leads, scan cards, enrich profiles automatically.",
    "hdr.item.pipelines.t": "Pipelines & Tasks",
    "hdr.item.pipelines.d": "Move deals forward with smart workflows.",
    "hdr.item.analytics.t": "Analytics",
    "hdr.item.analytics.d": "Real-time dashboards across every Banana product.",
    "hdr.item.bookings.t": "Bookings & Meetings",
    "hdr.item.bookings.d": "Let clients book directly from your card.",
    "hdr.item.contracts.t": "Contracts & e-Sign",
    "hdr.item.contracts.d": "Send, track and e-sign legally binding docs.",
    "hdr.item.automations.t": "Automations",
    "hdr.item.automations.d": "Triggers and actions that work while you sleep.",
    "hdr.item.reviews.t": "Reviews",
    "hdr.item.reviews.d": "Collect 5-star reviews on autopilot.",
    "hdr.item.integrations.t": "Integrations",
    "hdr.item.integrations.d": "Plug into Google, Outlook, Zapier and 50+ tools.",
    "hdr.item.forms.t": "Forms & Lead Capture",
    "hdr.item.forms.d": "Embeddable forms that drop straight into your CRM.",
    "hdr.sol.sales.t": "For Sales Teams",
    "hdr.sol.sales.d": "Win more deals in less time.",
    "hdr.sol.founders.t": "For Founders",
    "hdr.sol.founders.d": "Never lose a connection again.",
    "hdr.sol.realestate.t": "For Real Estate",
    "hdr.sol.realestate.d": "Stay top of mind with every client.",
    "hdr.sol.enterprise.t": "For Enterprise",
    "hdr.sol.enterprise.d": "SSO, security, and seat-based billing.",
    "hdr.prod.gold.t": "24kt Gold AI Card",
    "hdr.prod.gold.d": "Luxury 24kt gold plated NFC card — designed to impress.",
    "hdr.prod.metal.t": "Custom Metal AI Card",
    "hdr.prod.metal.d": "Premium metal NFC card built to last and powered by AI.",
    "hdr.prod.bamboo.t": "Bamboo AI Card",
    "hdr.prod.bamboo.d": "Sustainable bamboo NFC card — smart, natural, unforgettable.",
    "hdr.prod.white.t": "White PVC AI Card",
    "hdr.prod.white.d": "Clean white NFC card that shares your profile instantly.",
    "hdr.prod.black.t": "Black PVC AI Card",
    "hdr.prod.black.d": "Sleek black NFC card — works with Banana's AI tools.",
    "hdr.prod.google.t": "Google Review Card",
    "hdr.prod.google.d": "One tap sends customers to your Google reviews.",
    "hdr.badge.luxury": "Luxury",
    "hdr.badge.premium": "Premium",
    "hdr.badge.eco": "Eco",
    "hdr.badge.bestseller": "Bestseller",
    "hdr.from": "From",
    "cta.getStartedFree": "Get started — free",
    "cta.seePricing": "See pricing",
    "cta.talkToSales": "Talk to sales",
    "cta.learnMore": "Learn more",
    "platform.whatsInside": "What's inside",
    "platform.everythingTitle": "Everything you need,",
    "platform.everythingItalic": "in one place.",
    "feat.howItWorks": "How it works",
    "feat.liveInMinutes.title": "Live in minutes, not",
    "feat.liveInMinutes.italic": "months.",
    "feat.step": "Step",
    "feat.capabilities": "Capabilities",
    "feat.builtTo.title": "Built to",
    "feat.builtTo.italic": "go the distance.",
    "feat.capabilities.desc": "Every plan ships with the essentials. Upgrade only for team-scale, advanced security, and AI usage at volume.",
    "feat.comparePlans": "Compare plans",
    "feat.faq": "FAQ",
    "feat.questions.title": "Questions,",
    "feat.questions.italic": "answered.",
  },
  vi: {
    "nav.products": "Sản phẩm",
    "nav.platform": "Nền tảng",
    "nav.solutions": "Giải pháp",
    "nav.teams": "Đội nhóm",
    "nav.pricing": "Bảng giá",
    "nav.signIn": "Đăng nhập",
    "nav.getStarted": "Bắt đầu",
    "nav.openMenu": "Mở menu",
    "nav.shopAll": "Xem tất cả →",
    "nav.allProducts": "Tất cả sản phẩm",
    "nav.allProductsDesc": "Danh thiếp NFC được hỗ trợ bởi Banana AI.",
    "nav.forTeams": "Cho đội nhóm",
    "nav.teamsHeadline": "Bạn là một đội nhóm? Nhận báo giá riêng cho cả nhóm — hoặc nhiều nhóm.",
    "nav.teamsBody": "Thẻ thương hiệu, giá theo số lượng, bảng điều khiển chung và CRM dùng chung. Giao tất cả trong một lần.",
    "nav.talkToSales": "Liên hệ kinh doanh →",
    "nav.bulkPricing": "Giá số lượng",
    "nav.bulkBody": "Giảm đến 40% cho đơn từ 25 thẻ.",
    "nav.getQuote": "Nhận báo giá →",
    "nav.brandedQ": "Cần thẻ in thương hiệu cho cả đội?",
    "nav.whatsNew": "Mới ra mắt",
    "nav.brainNew": "AI Brain 2.0 — bộ não thứ hai của bạn, giờ đây đa ngôn ngữ.",
    "nav.brainBody": "Quét, làm giàu dữ liệu và theo dõi bằng hơn 50 ngôn ngữ. Có trên mọi gói.",
    "nav.readAnnouncement": "Đọc thông báo →",
    "nav.tryFree": "Dùng thử miễn phí",
    "nav.tryFreeBody": "Dùng thử Pro 14 ngày — không cần thẻ.",
    "nav.getStartedArrow": "Bắt đầu →",
    "nav.overviewQ": "Muốn xem tổng quan nền tảng?",
    "nav.seePlans": "Xem gói & giá →",
    "nav.customerStory": "Câu chuyện khách hàng",
    "nav.northbeam": "Theo dõi nhanh hơn 65× tại Northbeam.",
    "nav.readStory": "Đọc câu chuyện →",
    "nav.shopProducts": "Mua sản phẩm",
    "nav.nfcShop": "Cửa hàng NFC",
    "nav.about": "Giới thiệu",
    "nav.readAnnouncementMobile": "Đọc thông báo",
    "footer.tagline": "Nền tảng liên hệ tích hợp AI giúp các chuyên gia hiện đại chia sẻ bản thân, ghi lại người mình gặp và không bao giờ đánh mất ngữ cảnh.",
    "footer.col.platform": "Nền tảng",
    "footer.col.solutions": "Giải pháp",
    "footer.col.company": "Công ty",
    "footer.col.resources": "Tài nguyên",
    "footer.platform.cards": "Thẻ số",
    "footer.platform.ai": "AI Brain",
    "footer.platform.contacts": "Danh bạ",
    "footer.platform.bookings": "Đặt lịch",
    "footer.platform.contracts": "Hợp đồng",
    "footer.platform.automations": "Tự động hoá",
    "footer.platform.analytics": "Phân tích",
    "footer.solutions.sales": "Đội bán hàng",
    "footer.solutions.founders": "Nhà sáng lập",
    "footer.solutions.realEstate": "Bất động sản",
    "footer.solutions.enterprise": "Doanh nghiệp",
    "footer.company.about": "Giới thiệu",
    "footer.company.pricing": "Bảng giá",
    "footer.company.shop": "Cửa hàng NFC",
    "footer.company.contact": "Liên hệ",
    "footer.resources.help": "Trung tâm trợ giúp",
    "footer.resources.articles": "Bài viết",
    "footer.resources.legal": "Pháp lý",
    "footer.resources.security": "Bảo mật",
    "footer.resources.antiSpam": "Chính sách Chống thư rác",
  "footer.resources.returns": "Chính sách Đổi trả",
    "footer.copyright": "Bảo lưu mọi quyền.",
    "footer.madeWith": "Được tạo ra với sự tận tâm cho những người gặp gỡ con người.",
    "switcher.label": "Ngôn ngữ",
    "viOnlyEnNotice": "Trang này hiện chỉ có bằng tiếng Anh.",
    "hdr.group.identity": "Danh tính & Chia sẻ",
    "hdr.group.ai": "AI",
    "hdr.group.crm": "CRM",
    "hdr.group.run": "Vận hành doanh nghiệp",
    "hdr.item.cards.t": "Danh thiếp số",
    "hdr.item.cards.d": "Hồ sơ đẹp, có thể tuỳ chỉnh cho mọi thành viên đội nhóm.",
    "hdr.item.nfc.t": "Thẻ NFC",
    "hdr.item.nfc.d": "Sản phẩm NFC cao cấp — chạm để chia sẻ tức thì.",
    "hdr.item.sharing.t": "Chia sẻ & Kết nối",
    "hdr.item.sharing.d": "Mã QR, Apple & Google Wallet, chữ ký email.",
    "hdr.item.brain.t": "AI Brain",
    "hdr.item.brain.d": "Bộ não thứ hai cho mọi liên hệ và cuộc trò chuyện.",
    "hdr.item.enrich.t": "Làm giàu dữ liệu bằng AI",
    "hdr.item.enrich.d": "Tự động điền chức danh, công ty và tín hiệu cho mọi liên hệ.",
    "hdr.item.aitools.t": "Công cụ AI",
    "hdr.item.aitools.d": "Viết, dịch, tóm tắt và chấm điểm khách hàng tiềm năng.",
    "hdr.item.contacts.t": "Danh bạ",
    "hdr.item.contacts.d": "Ghi nhận khách hàng tiềm năng, quét thẻ, làm giàu hồ sơ tự động.",
    "hdr.item.pipelines.t": "Pipeline & Công việc",
    "hdr.item.pipelines.d": "Đẩy thương vụ tiến tới với quy trình thông minh.",
    "hdr.item.analytics.t": "Phân tích",
    "hdr.item.analytics.d": "Bảng điều khiển thời gian thực cho mọi sản phẩm Banana.",
    "hdr.item.bookings.t": "Đặt lịch & Cuộc họp",
    "hdr.item.bookings.d": "Cho phép khách đặt lịch trực tiếp từ thẻ của bạn.",
    "hdr.item.contracts.t": "Hợp đồng & Ký điện tử",
    "hdr.item.contracts.d": "Gửi, theo dõi và ký điện tử tài liệu có giá trị pháp lý.",
    "hdr.item.automations.t": "Tự động hoá",
    "hdr.item.automations.d": "Trigger và hành động chạy ngay cả khi bạn ngủ.",
    "hdr.item.reviews.t": "Đánh giá",
    "hdr.item.reviews.d": "Thu thập đánh giá 5 sao tự động.",
    "hdr.item.integrations.t": "Tích hợp",
    "hdr.item.integrations.d": "Kết nối với Google, Outlook, Zapier và hơn 50 công cụ.",
    "hdr.item.forms.t": "Biểu mẫu & Thu thập khách hàng",
    "hdr.item.forms.d": "Biểu mẫu nhúng đưa thẳng vào CRM của bạn.",
    "hdr.sol.sales.t": "Cho đội bán hàng",
    "hdr.sol.sales.d": "Chốt nhiều thương vụ hơn trong thời gian ngắn hơn.",
    "hdr.sol.founders.t": "Cho nhà sáng lập",
    "hdr.sol.founders.d": "Không bao giờ đánh mất một kết nối.",
    "hdr.sol.realestate.t": "Cho bất động sản",
    "hdr.sol.realestate.d": "Luôn ở trong tâm trí mọi khách hàng.",
    "hdr.sol.enterprise.t": "Cho doanh nghiệp",
    "hdr.sol.enterprise.d": "SSO, bảo mật và thanh toán theo số ghế.",
    "hdr.prod.gold.t": "Thẻ AI Vàng 24kt",
    "hdr.prod.gold.d": "Thẻ NFC mạ vàng 24kt sang trọng — thiết kế để gây ấn tượng.",
    "hdr.prod.metal.t": "Thẻ AI Kim Loại Tùy Chỉnh",
    "hdr.prod.metal.d": "Thẻ NFC kim loại cao cấp bền bỉ, được hỗ trợ bởi AI.",
    "hdr.prod.bamboo.t": "Thẻ AI Tre",
    "hdr.prod.bamboo.d": "Thẻ NFC tre bền vững — thông minh, tự nhiên, khó quên.",
    "hdr.prod.white.t": "Thẻ AI PVC Trắng",
    "hdr.prod.white.d": "Thẻ NFC trắng sạch — chia sẻ hồ sơ của bạn ngay lập tức.",
    "hdr.prod.black.t": "Thẻ AI PVC Đen",
    "hdr.prod.black.d": "Thẻ NFC đen thanh lịch — hoạt động cùng công cụ AI của Banana.",
    "hdr.prod.google.t": "Thẻ Đánh giá Google",
    "hdr.prod.google.d": "Một cú chạm gửi khách hàng đến trang đánh giá Google của bạn.",
    "hdr.badge.luxury": "Sang trọng",
    "hdr.badge.premium": "Cao cấp",
    "hdr.badge.eco": "Xanh",
    "hdr.badge.bestseller": "Bán chạy",
    "hdr.from": "Từ",
    "cta.getStartedFree": "Bắt đầu — miễn phí",
    "cta.seePricing": "Xem bảng giá",
    "cta.talkToSales": "Liên hệ kinh doanh",
    "cta.learnMore": "Tìm hiểu thêm",
    "platform.whatsInside": "Bên trong có gì",
    "platform.everythingTitle": "Mọi thứ bạn cần,",
    "platform.everythingItalic": "trong một nơi.",
    "feat.howItWorks": "Cách hoạt động",
    "feat.liveInMinutes.title": "Chạy trong vài phút, không phải",
    "feat.liveInMinutes.italic": "vài tháng.",
    "feat.step": "Bước",
    "feat.capabilities": "Tính năng",
    "feat.builtTo.title": "Được xây dựng để",
    "feat.builtTo.italic": "đi đường dài.",
    "feat.capabilities.desc": "Mọi gói đều có sẵn những gì thiết yếu. Nâng cấp chỉ khi cần quy mô đội nhóm, bảo mật nâng cao và AI dùng ở khối lượng lớn.",
    "feat.comparePlans": "So sánh các gói",
    "feat.faq": "Câu hỏi thường gặp",
    "feat.questions.title": "Câu hỏi,",
    "feat.questions.italic": "đã được giải đáp.",
  },
  el: {
  "nav.products": "Προϊόντα",
  "nav.platform": "Πλατφόρμα",
  "nav.solutions": "Λύσεις",
  "nav.teams": "Ομάδες",
  "nav.pricing": "Τιμές",
  "nav.signIn": "Σύνδεση",
  "nav.getStarted": "Ξεκινήστε",
  "nav.openMenu": "Άνοιγμα μενού",
  "nav.shopAll": "Δείτε όλα →",
  "nav.allProducts": "Όλα τα προϊόντα",
  "nav.allProductsDesc": "Επαγγελματικές κάρτες NFC με την υποστήριξη της Banana AI.",
  "nav.forTeams": "Για ομάδες",
  "nav.teamsHeadline": "Είστε ομάδα; Ζητήστε εξατομικευμένη προσφορά για όλη την ομάδα σας — ή για τις ομάδες σας.",
  "nav.teamsBody": "Κάρτες με το λογότυπό σας, τιμές χονδρικής, κεντρικός πίνακας ελέγχου και κοινό CRM. Όλα σε μία αποστολή.",
  "nav.talkToSales": "Μιλήστε με τις πωλήσεις →",
  "nav.bulkPricing": "Τιμές χονδρικής",
  "nav.bulkBody": "Έως 40% έκπτωση για 25+ κάρτες.",
  "nav.getQuote": "Ζητήστε προσφορά →",
  "nav.brandedQ": "Χρειάζεστε κάρτες με το λογότυπό σας για την ομάδα;",
  "nav.whatsNew": "Τι νέο υπάρχει",
  "nav.brainNew": "AI Brain 2.0 — ο δεύτερος εγκέφαλός σας, τώρα σε πολλές γλώσσες.",
  "nav.brainBody": "Σαρώστε, εμπλουτίστε δεδομένα και κάντε επαναεπικοινωνία σε 50+ γλώσσες. Διαθέσιμο σε κάθε πρόγραμμα.",
  "nav.readAnnouncement": "Διαβάστε την ανακοίνωση →",
  "nav.tryFree": "Δοκιμάστε δωρεάν",
  "nav.tryFreeBody": "Δοκιμή Pro 14 ημερών — χωρίς κάρτα.",
  "nav.getStartedArrow": "Ξεκινήστε →",
  "nav.overviewQ": "Αναζητάτε μια πλήρη επισκόπηση της πλατφόρμας;",
  "nav.seePlans": "Δείτε προγράμματα και τιμές →",
  "nav.customerStory": "Ιστορία πελάτη",
  "nav.northbeam": "65× ταχύτερη επαναεπικοινωνία στη Northbeam.",
  "nav.readStory": "Διαβάστε την ιστορία →",
  "nav.shopProducts": "Αγορά προϊόντων",
  "nav.nfcShop": "Κατάστημα NFC",
  "nav.about": "Σχετικά",
  "nav.readAnnouncementMobile": "Διαβάστε την ανακοίνωση",
  "footer.tagline": "Η πλατφόρμα επαφών με AI που βοηθά τους σύγχρονους επαγγελματίες να συστήνονται, να καταγράφουν τις γνωριμίες τους και να διατηρούν όλο το πλαίσιο κάθε σχέσης.",
  "footer.col.platform": "Πλατφόρμα",
  "footer.col.solutions": "Λύσεις",
  "footer.col.company": "Εταιρεία",
  "footer.col.resources": "Πόροι",
  "footer.platform.cards": "Ψηφιακές κάρτες",
  "footer.platform.ai": "AI Brain",
  "footer.platform.contacts": "Επαφές",
  "footer.platform.bookings": "Κρατήσεις",
  "footer.platform.contracts": "Συμβάσεις",
  "footer.platform.automations": "Αυτοματισμοί",
  "footer.platform.analytics": "Αναλυτικά στοιχεία",
  "footer.solutions.sales": "Ομάδες πωλήσεων",
  "footer.solutions.founders": "Ιδρυτές",
  "footer.solutions.realEstate": "Ακίνητα",
  "footer.solutions.enterprise": "Μεγάλες επιχειρήσεις",
  "footer.company.about": "Σχετικά",
  "footer.company.pricing": "Τιμές",
  "footer.company.shop": "Κατάστημα NFC",
  "footer.company.contact": "Επικοινωνία",
  "footer.resources.help": "Κέντρο βοήθειας",
  "footer.resources.articles": "Άρθρα",
  "footer.resources.legal": "Νομικά",
  "footer.resources.security": "Ασφάλεια",
  "footer.resources.antiSpam": "Πολιτική κατά των ανεπιθύμητων μηνυμάτων",
  "footer.resources.returns": "Πολιτική επιστροφών",
  "footer.copyright": "Με επιφύλαξη παντός δικαιώματος.",
  "footer.madeWith": "Φτιαγμένο με φροντίδα για ανθρώπους που γνωρίζουν ανθρώπους.",
  "switcher.label": "Γλώσσα",
  "viOnlyEnNotice": "Αυτή η σελίδα είναι προς το παρόν διαθέσιμη μόνο στα Αγγλικά.",
  "hdr.group.identity": "Ταυτότητα και κοινοποίηση",
  "hdr.group.ai": "AI",
  "hdr.group.crm": "CRM",
  "hdr.group.run": "Διαχειριστείτε την επιχείρησή σας",
  "hdr.item.cards.t": "Ψηφιακές επαγγελματικές κάρτες",
  "hdr.item.cards.d": "Καλαίσθητα, εξατομικεύσιμα προφίλ για όλους στην ομάδα σας.",
  "hdr.item.nfc.t": "Κάρτες NFC",
  "hdr.item.nfc.d": "Κορυφαία προϊόντα NFC — αγγίξτε για άμεση κοινοποίηση.",
  "hdr.item.sharing.t": "Κοινοποίηση και δικτύωση",
  "hdr.item.sharing.d": "Κωδικοί QR, Apple Wallet και Google Wallet, υπογραφές email.",
  "hdr.item.brain.t": "AI Brain",
  "hdr.item.brain.d": "Ο δεύτερος εγκέφαλός σας για κάθε επαφή και συνομιλία.",
  "hdr.item.enrich.t": "Εμπλουτισμός με AI",
  "hdr.item.enrich.d": "Συμπληρώστε αυτόματα τίτλο, εταιρεία και σημαντικά στοιχεία για κάθε επαφή.",
  "hdr.item.aitools.t": "Εργαλεία AI",
  "hdr.item.aitools.d": "Συγγραφή, μετάφραση, σύνοψη και αξιολόγηση δυνητικών πελατών.",
  "hdr.item.contacts.t": "Επαφές",
  "hdr.item.contacts.d": "Καταγράψτε δυνητικούς πελάτες, σαρώστε κάρτες και εμπλουτίστε αυτόματα προφίλ.",
  "hdr.item.pipelines.t": "Ροές πωλήσεων και εργασίες",
  "hdr.item.pipelines.d": "Προωθήστε τις συμφωνίες με έξυπνες ροές εργασιών.",
  "hdr.item.analytics.t": "Αναλυτικά στοιχεία",
  "hdr.item.analytics.d": "Πίνακες ελέγχου σε πραγματικό χρόνο για όλα τα προϊόντα Banana.",
  "hdr.item.bookings.t": "Κρατήσεις και συναντήσεις",
  "hdr.item.bookings.d": "Δώστε στους πελάτες τη δυνατότητα να κλείνουν ραντεβού απευθείας από την κάρτα σας.",
  "hdr.item.contracts.t": "Συμβάσεις και ηλεκτρονική υπογραφή",
  "hdr.item.contracts.d": "Στείλτε, παρακολουθήστε και υπογράψτε ηλεκτρονικά νομικά δεσμευτικά έγγραφα.",
  "hdr.item.automations.t": "Αυτοματισμοί",
  "hdr.item.automations.d": "Εναύσματα και ενέργειες που λειτουργούν όσο εσείς ξεκουράζεστε.",
  "hdr.item.reviews.t": "Κριτικές",
  "hdr.item.reviews.d": "Συλλέξτε κριτικές 5 αστέρων αυτόματα.",
  "hdr.item.integrations.t": "Ενσωματώσεις",
  "hdr.item.integrations.d": "Συνδεθείτε με Google, Outlook, Zapier και 50+ εργαλεία.",
  "hdr.item.forms.t": "Φόρμες και συλλογή δυνητικών πελατών",
  "hdr.item.forms.d": "Ενσωματώσιμες φόρμες που καταχωρίζουν τα στοιχεία απευθείας στο CRM σας.",
  "hdr.sol.sales.t": "Για ομάδες πωλήσεων",
  "hdr.sol.sales.d": "Κλείστε περισσότερες συμφωνίες σε λιγότερο χρόνο.",
  "hdr.sol.founders.t": "Για ιδρυτές",
  "hdr.sol.founders.d": "Μην χάσετε ποτέ ξανά μια σημαντική επαφή.",
  "hdr.sol.realestate.t": "Για τον κλάδο ακινήτων",
  "hdr.sol.realestate.d": "Παραμείνετε στη σκέψη κάθε πελάτη.",
  "hdr.sol.enterprise.t": "Για μεγάλες επιχειρήσεις",
  "hdr.sol.enterprise.d": "SSO, ασφάλεια και χρέωση ανά χρήστη.",
  "hdr.prod.gold.t": "Κάρτα AI από χρυσό 24kt",
  "hdr.prod.gold.d": "Πολυτελής κάρτα NFC επιχρυσωμένη με χρυσό 24kt — σχεδιασμένη να εντυπωσιάζει.",
  "hdr.prod.metal.t": "Εξατομικευμένη μεταλλική κάρτα AI",
  "hdr.prod.metal.d": "Ανθεκτική premium μεταλλική κάρτα NFC με AI.",
  "hdr.prod.bamboo.t": "Κάρτα AI από μπαμπού",
  "hdr.prod.bamboo.d": "Βιώσιμη κάρτα NFC από μπαμπού — έξυπνη, φυσική, αξέχαστη.",
  "hdr.prod.white.t": "Λευκή κάρτα PVC AI",
  "hdr.prod.white.d": "Κομψή λευκή κάρτα NFC που κοινοποιεί αμέσως το προφίλ σας.",
  "hdr.prod.black.t": "Μαύρη κάρτα PVC AI",
  "hdr.prod.black.d": "Κομψή μαύρη κάρτα NFC — συμβατή με τα εργαλεία AI της Banana.",
  "hdr.prod.google.t": "Κάρτα κριτικών Google",
  "hdr.prod.google.d": "Με ένα άγγιγμα, οι πελάτες σας οδηγούνται στις κριτικές σας στο Google.",
  "hdr.badge.luxury": "Πολυτελές",
  "hdr.badge.premium": "Premium",
  "hdr.badge.eco": "Οικολογικό",
  "hdr.badge.bestseller": "Bestseller",
  "hdr.from": "Από",
  "cta.getStartedFree": "Ξεκινήστε — δωρεάν",
  "cta.seePricing": "Δείτε τις τιμές",
  "cta.talkToSales": "Μιλήστε με τις πωλήσεις",
  "cta.learnMore": "Μάθετε περισσότερα",
  "platform.whatsInside": "Τι περιλαμβάνει",
  "platform.everythingTitle": "Όλα όσα χρειάζεστε,",
  "platform.everythingItalic": "σε ένα μέρος.",
  "feat.howItWorks": "Πώς λειτουργεί",
  "feat.liveInMinutes.title": "Έτοιμοι σε λίγα λεπτά, όχι",
  "feat.liveInMinutes.italic": "σε μήνες.",
  "feat.step": "Βήμα",
  "feat.capabilities": "Δυνατότητες",
  "feat.builtTo.title": "Σχεδιασμένο για",
  "feat.builtTo.italic": "να αντέχει στον χρόνο.",
  "feat.capabilities.desc": "Κάθε πρόγραμμα περιλαμβάνει όλα τα βασικά. Αναβαθμίστε μόνο για ομάδες, προηγμένη ασφάλεια και εκτεταμένη χρήση AI.",
  "feat.comparePlans": "Συγκρίνετε προγράμματα",
  "feat.faq": "Συχνές ερωτήσεις",
  "feat.questions.title": "Ερωτήσεις,",
  "feat.questions.italic": "απαντημένες.",
  },
} as const;

export type ChromeKey = keyof (typeof CHROME)["en"];

export function useT(): (key: ChromeKey) => string {
  const locale = useLocale();
  return (key) => (CHROME[locale] as Record<string, string>)[key] ?? (CHROME.en as Record<string, string>)[key] ?? key;
}

/** Translate by locale + key (for use outside React). */
export function t(locale: Locale, key: ChromeKey): string {
  return (CHROME[locale] as Record<string, string>)[key] ?? (CHROME.en as Record<string, string>)[key] ?? key;
}